class Pagination
    constructor: (el) ->
        @.$el = el
        @.$nextButton = @.$el.querySelector '.pagination__next'
        @.$pagesLinks = @.$el.querySelectorAll 'ul li a'
        @.$prevButton = @.$el.querySelector '.pagination__prev'

        @.activePage = parseInt (if @.$el.querySelector('.pagination__link--active') then (@.$el.querySelector('.pagination__link--active').dataset?.index ? 1) else 1), 10
        @.maxShownItems = parseInt @.$el.dataset?.maxShownItems ? 20, 10

        if !@.$el.querySelector('.pagination__link--active')
            @.SetActivePage 1
        @.$el.classList.add 'pagination--bound'
        @.InitEvents()
        @.InitPagesLinksEvents()
        @.CheckButtonStates()
        @.HandleShownItems()
        return

    AddPage: (pageNo) ->
        newPaginationEl = document.createElement 'li'
        newPaginationEl.innerHTML = "
            <a class='pagination__link--pd' href='#page-#{ pageNo }' data-index='#{ pageNo }'>#{ pageNo }</a>
        "
        @.$el.querySelector 'ul'
            .appendChild newPaginationEl
        return
    
    CheckButtonStates: ->
        @.$prevButton.disabled = @.activePage == 1
        @.$nextButton.disabled = @.activePage == @.$pagesLinks.length
        return

    HandleShownItems: ->
        itemsSpacerEl = @.$el.querySelector '.pagination__items-spacer'
        if itemsSpacerEl
            itemsSpacerEl.remove()
        if @.$pagesLinks.length > @.maxShownItems
            @.$pagesLinks.forEach (pageLinkEl) ->
                pageLinkEl.closest('li').classList.remove 'pagination__item--half'
                pageLinkEl.closest('li').classList.add 'pagination__item--hidden'
                return
            pagesLinksArray = Array.from(@.$pagesLinks)
            itemsSpacerEl = document.createElement 'li'
            itemsSpacerEl.classList.add 'pagination__items-spacer'
            pagesLinksArrayFromActivePage = pagesLinksArray.slice ((pagesLinksArray.length - (@.activePage - 1)) * -1)
            for i in [0..@.maxShownItems - 2]
                if pagesLinksArrayFromActivePage.length >= @.maxShownItems
                    if @.activePage > @.maxShownItems - 2
                        if pagesLinksArrayFromActivePage[i]
                            pagesLinksArrayFromActivePage[i].closest('li').classList.remove 'pagination__item--hidden'
                        if i == @.maxShownItems - 2
                            firstPageEl = pagesLinksArray[0]
                            if firstPageEl
                                firstPageEl.closest('li').classList.remove 'pagination__item--hidden'
                                firstPageEl.closest('li').after itemsSpacerEl
                    else
                        if pagesLinksArray[i]
                            pagesLinksArray[i].closest('li').classList.remove 'pagination__item--hidden'
                    if i == @.maxShownItems - 2
                        lastPagesLinkEl = pagesLinksArray[pagesLinksArray.length - 1]
                    if lastPagesLinkEl
                        lastPagesLinkEl.closest('li').classList.remove 'pagination__item--hidden'
                        lastPagesLinkEl.closest('li').before itemsSpacerEl.cloneNode()
                else
                    pageLinkEl = pagesLinksArray[pagesLinksArray.length - (1+i)]
                    if pageLinkEl
                        pageLinkEl.closest('li').classList.remove 'pagination__item--hidden'
                    if i == @maxShownItems - 2
                        firstPageEl = pagesLinksArray[0]
                        if firstPageEl
                            firstPageEl.closest('li').classList.remove 'pagination__item--hidden'
                            firstPageEl.closest('li').after itemsSpacerEl
        return
    
    InitEvents: ->
        self = @
        @.$nextButton.addEventListener 'click', (e) ->
            if !self.$nextButton.disabled
                self.SetActivePage self.activePage + 1
            return
        @.$prevButton.addEventListener 'click', (e) ->
            if !self.$prevButton.disabled
                self.SetActivePage self.activePage - 1
            return
        @.$el.addEventListener 'pagination-set-active-page', (e) ->
            activePage = e.detail?.page ? 1
            self.SetActivePage activePage, true
            return
        @.$el.addEventListener 'pagination-update-pages', (e) ->
            pagesCount = e.detail?.pagesCount ? self.$pagesLinks.length
            self.UpdatePages pagesCount
            return
        return
    
    InitPagesLinksEvents: ->
        self = @
        @.$pagesLinks.forEach (pageLink) ->
            if !pageLink.classList.contains('pagination__link--bound')
                pageLink.addEventListener 'click', (e) ->
                    if @.classList.contains('pagination__link--pd')
                        e.preventDefault()
                    self.SetActivePage (if @.dataset?.index then parseInt(@.dataset?.index,10) else 1)
                    return
                pageLink.classList.add 'pagination__link--bound'
            return
        return
    
    SetActivePage: (activePage, forced) ->
        forced = forced ? false
        formerActivePageEl = @.$el.querySelector '.pagination__link--active'
        if formerActivePageEl
            formerActivePageEl.classList.remove 'pagination__link--active'
        newActivePageEl = @.$pagesLinks[activePage - 1]
        if newActivePageEl
            @.activePage = activePage
            newActivePageEl.classList.add 'pagination__link--active'
            if !forced
                self = @
                @.$el.dispatchEvent new CustomEvent 'pagination-active-page-set', {
                    bubbles: false
                    detail: {
                        activePage: self.activePage
                    }
                }
        if formerActivePageEl != newActivePageEl
            if !newActivePageEl.classList.contains 'pagination__link--pd'
                newActivePageEl.click()
        @.CheckButtonStates()
        @.HandleShownItems()
        return
    
    UpdatePages: (pagesCount) ->
        if pagesCount > @.$pagesLinks.length
            for newPage in [(@.$pagesLinks.length+1)..pagesCount]
                @.AddPage newPage
            @.$pagesLinks = @.$el.querySelectorAll 'ul li a'
            @.InitPagesLinksEvents()
            @.$nextButton.disabled = @.activePage == @.$pagesLinks.length
        if pagesCount < @.$pagesLinks.length
            count = 1
            @.$pagesLinks.forEach (pageLink) ->
                if count > pagesCount
                    pageLink.closest('li').remove()
                count++
            @.$pagesLinks = @.$el.querySelectorAll 'ul li a'
            if @.activePage > pagesCount
                @.SetActivePage pagesCount
            else
                @.HandleShownItems()
            @.$nextButton.disabled = @.activePage == @.$pagesLinks.length
        return

BindPaginations = ->
    document.querySelectorAll '.pagination:not(.pagination--bound)'
        .forEach (el) ->
            new Pagination el
            return
    return

window.addEventListener 'bind-components', BindPaginations